<template>
    <div ref="homeiphone" 
      @touchmove="handleTouchMove">
      <CalendarPicker
        @setOption="setOption"
        @close-picker="gobackToHomeFromFilter"
        v-if="currentScreen == pickerpath" />
      <OptionSelectorView
        v-if="currentScreen == rootpath"
        @showpicker="setPickerVisible"
        @setOption="setOption" />
      <FiltersDetailView 
          v-if="currentScreen == filterpath"
          @setOption="setOption"
          @formsubmitted="addListViewToPath"
          :gobackfn="gobackfn" /> 
      <EventsCalendarList
        v-if="currentScreen == listpath"
        @setOption="setOption" />
    </div>
</template>

<script>
import { computed } from "vue";
import EventsCalendarList from '@/containers/mobile/EventsCalendarList.vue';
import CalendarPicker from '@/containers/mobile/CalendarPicker.vue';
import OptionSelectorView from '@/containers/mobile/OptionSelectorView.vue';
import FiltersDetailView from '@/containers/mobile/FiltersDetailView.vue';
import { useMenuStore } from "@/stores/menu.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";


const ROOTPATH = 1;
const PICKERPATH = 2;
const LISTPATH = 3;
const FILTERPATH = 4;

export default {
  name: 'IphoneView',
  components: {
    EventsCalendarList,
    CalendarPicker,
    OptionSelectorView,
    FiltersDetailView,
  },
  setup(){
    const eventsearch = useEventSearch();
    const searchedFilter = computed(()=> eventsearch.searchedFilter);

    const menuStore = useMenuStore();
    function handleSelect(id) {
      menuStore.selectMenuItem(id);
    }
    return {
      handleSelect,
      searchedFilter
    }
  },
  data(){
    return {
      showCalendar: false,
      touchStartY: 0,
      isOnCalendar: false,
      path:[ROOTPATH],
    }
  },
  computed:{
    showPickerView(){
      return this.currentScreen == PICKERPATH;
    },
    showCalendarView(){
      return this.currentScreen == LISTPATH;
    },
    showFiltersView(){
      return this.currentScreen == FILTERPATH;
    },
    rootpath: () => ROOTPATH,
    pickerpath: () => PICKERPATH,
    listpath: () => LISTPATH,
    filterpath: () => FILTERPATH,
    lastNavigation(){
      return this.path.length > 0 ? this.path[this.path.length-2] : this.path[0];
    },
    currentScreen(){
      return this.path[this.path.length-1]; 
    },
    gobackfn(){
      if(this.lastNavigation == ROOTPATH){
        return this.gobackToHomeFromFilter;
      }
      if(this.lastNavigation == PICKERPATH){
        return this.setPickerVisibleOnBack;
      }
      if(this.lastNavigation == LISTPATH){
        return this.goToCalendarFromFilter;
      }
    },
  },
  provide(){
    return {
      toogleIsOnCalendar: this.handleEmit,
      showEventList: this.addListViewToPath
    }
  },
  methods:{
    addListViewToPath(){
      this.path.push(LISTPATH);
    },
    goToCalendarFromFilter(){
      this.handleSelect(this.searchedFilter.id)
      this.path.pop();
    },
    gobackToHomeFromFilter(){
      this.handleSelect(null)
      this.path.pop();
    },
    setPickerVisibleOnBack(){
      this.path.pop();
    },
    setPickerVisible(){
      this.path.push(PICKERPATH);
    },
    handleEmit(){
      this.isOnCalendar = !this.isOnCalendar;
    },
    handleTouchMove(event){
      if(this.isOnCalendar){
        event.preventDefault();
      }      
    },
    setOption(option){
      if(this.currentScreen != FILTERPATH){
        this.path.push(FILTERPATH);
      }
      this.handleSelect(option.id)
    }
  }
}
</script>

<style scoped>
  .fixedtobottom{
    position: fixed;
  }
</style>